type GtagCommand = 'config' | 'event' | 'set';

interface EventParams {
  [key: string]: string | number | boolean | undefined;
}

function gtag(command: GtagCommand, ...args: unknown[]) {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag(command, ...args);
}

/** Track a page view */
export function trackPageView(path: string, title?: string) {
  gtag('event', 'page_view', {
    page_path: path,
    page_title: title,
  });
}

/** Track a custom event */
export function trackEvent(name: string, params?: EventParams) {
  gtag('event', name, params);
}

/**
 * Track a key conversion event.
 * Identical to trackEvent — GA4 conversions are marked in the GA4 admin console,
 * not in code. This wrapper exists purely for readability so conversion events
 * stand out in the codebase.
 */
export function trackConversion(name: string, params?: EventParams) {
  gtag('event', name, params);
}

/** Set user properties for all subsequent events */
export function identifyUser(userId: string, properties?: EventParams) {
  gtag('set', { user_id: userId, ...properties });
}

// Extend Window for gtag
declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
    dataLayer: unknown[];
  }
}
